export default __webpack_public_path__ + "static/media/jumping2.3c175f51.jpg";